export const locationConstants = {
  BASE_PATH: '/v1/locations',
};
